import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./dstyle.css";
import SideBar from "./SideBar";
import Navbar from "./Navbar";
import { toast } from "react-toastify";
import { Modal } from "antd";
import { API_BASE_URL } from "../../config/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faSpinner,
  faCheckCircle,
  faTimes,
  faBookOpen,
  faFire
} from "@fortawesome/free-solid-svg-icons";

function DCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [categoryName, setCategoryName] = useState("");
  const [isTrending, setIsTrending] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("adminId")) {
      navigate("/admin-login");
      return;
    }
    fetchCategories();
  }, [navigate]);

  function fetchCategories() {
    setLoading(true);
    fetch(`${API_BASE_URL}/api/categories`)
      .then((res) => res.json())
      .then((data) => {
        setCategories(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  function toggleTrending(cat) {
    const currentVal = cat.is_trending === 1 || cat.is_trending === true;
    const newVal = currentVal ? 0 : 1;
    fetch(`${API_BASE_URL}/api/categories/${cat.id}/trending`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ is_trending: newVal })
    })
      .then((res) => res.json())
      .then(() => {
        toast.success(newVal ? `"${cat.name}" marked as Trending!` : `"${cat.name}" removed from Trending.`);
        fetchCategories();
      })
      .catch(() => {
        toast.error("Failed to update category trending status.");
      });
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!categoryName.trim()) {
      toast.error("Category name is required.");
      return;
    }
    setFormLoading(true);

    const url = editId
      ? `${API_BASE_URL}/api/categories/${editId}`
      : `${API_BASE_URL}/api/categories`;
    const method = editId ? "PUT" : "POST";

    fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ 
        name: categoryName.trim(),
        is_trending: isTrending ? 1 : 0
      })
    })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) {
          throw new Error(data.error || "Failed to save category.");
        }
        return data;
      })
      .then(() => {
        toast.success(editId ? "Category updated successfully!" : "Category created successfully!");
        setShowForm(false);
        setEditId(null);
        setCategoryName("");
        setIsTrending(false);
        fetchCategories();
      })
      .catch((err) => {
        toast.error(err.message || "Failed to save category.");
      })
      .finally(() => setFormLoading(false));
  }

  function handleEdit(cat) {
    setEditId(cat.id);
    setCategoryName(cat.name);
    setIsTrending(cat.is_trending === 1 || cat.is_trending === true);
    setShowForm(true);
  }

  function handleDelete() {
    if (!deleteId) return;
    fetch(`${API_BASE_URL}/api/categories/${deleteId}`, { method: "DELETE" })
      .then((res) => {
        if (!res.ok && res.status !== 204) {
          throw new Error("Failed to delete category");
        }
        toast.success("Category deleted successfully.");
        setDeleteModal(false);
        setDeleteId(null);
        fetchCategories();
      })
      .catch((err) => {
        toast.error(err.message || "Failed to delete category.");
      });
  }

  function handleCancel() {
    setShowForm(false);
    setEditId(null);
    setCategoryName("");
    setIsTrending(false);
  }

  return (
    <div style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      <SideBar current={"categories"} />
      <section id="content">
        <Navbar />
        <main style={{ padding: "28px" }}>

          {/* Header */}
          <div
            style={{
              marginBottom: "28px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "16px"
            }}
          >
            <div>
              <h1
                style={{
                  color: "#0f172a",
                  fontFamily: "'Outfit', sans-serif",
                  fontSize: "1.8rem",
                  fontWeight: 800,
                  margin: 0
                }}
              >
                Course Categories
              </h1>
              <p style={{ color: "#64748b", margin: "4px 0 0", fontSize: "0.9rem" }}>
                Create, edit, and organize course categories for your learning platform
              </p>
            </div>

            <button
              onClick={() => { setShowForm(true); setEditId(null); setCategoryName(""); }}
              style={{
                background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                padding: "10px 22px",
                fontWeight: 700,
                fontSize: "0.9rem",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                boxShadow: "0 4px 14px rgba(37, 99, 235, 0.3)"
              }}
            >
              <FontAwesomeIcon icon={faPlus} /> Add Category
            </button>
          </div>

          {/* Create / Edit Form */}
          {showForm && (
            <div
              style={{
                background: "#fff",
                borderRadius: "16px",
                border: "1px solid #e2e8f0",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                padding: "24px",
                marginBottom: "24px"
              }}
            >
              <h3 style={{
                margin: "0 0 16px",
                fontWeight: 800,
                color: "#0f172a",
                fontSize: "1.1rem"
              }}>
                {editId ? "Edit Category" : "Create New Category"}
              </h3>
              <form onSubmit={handleSubmit} style={{ display: "flex", gap: "14px", alignItems: "flex-end", flexWrap: "wrap" }}>
                <div style={{ flex: 1, minWidth: "260px" }}>
                  <label style={{ display: "block", color: "#334155", fontSize: "0.85rem", fontWeight: 700, marginBottom: "6px" }}>
                    Category Name *
                  </label>
                  <input
                    type="text"
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                    placeholder="e.g. Artificial Intelligence, Web Development, Data Science"
                    required
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      border: "1.5px solid #cbd5e1",
                      borderRadius: "10px",
                      fontSize: "0.95rem",
                      color: "#0f172a",
                      outline: "none",
                      boxSizing: "border-box"
                    }}
                    autoFocus
                  />
                </div>
                <div style={{ width: "100%", margin: "6px 0 8px" }}>
                  <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "0.88rem", fontWeight: 700, color: "#ea580c" }}>
                    <input
                      type="checkbox"
                      checked={isTrending}
                      onChange={(e) => setIsTrending(e.target.checked)}
                      style={{ width: "18px", height: "18px", cursor: "pointer", accentColor: "#ea580c" }}
                    />
                    <FontAwesomeIcon icon={faFire} />
                    Mark as Trending Category (featured in Navbar column 1)
                  </label>
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                  <button
                    type="submit"
                    disabled={formLoading}
                    style={{
                      background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                      color: "#fff",
                      border: "none",
                      padding: "12px 24px",
                      borderRadius: "10px",
                      fontWeight: 700,
                      cursor: formLoading ? "wait" : "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "0.9rem",
                      boxShadow: "0 4px 14px rgba(37, 99, 235, 0.3)"
                    }}
                  >
                    {formLoading ? (
                      <><FontAwesomeIcon icon={faSpinner} spin /> Saving...</>
                    ) : (
                      <><FontAwesomeIcon icon={faCheckCircle} /> {editId ? "Update Category" : "Save Category"}</>
                    )}
                  </button>
                  <button
                    type="button"
                    onClick={handleCancel}
                    style={{
                      background: "#f1f5f9",
                      color: "#475569",
                      border: "none",
                      padding: "12px 18px",
                      borderRadius: "10px",
                      fontWeight: 700,
                      cursor: "pointer",
                      fontSize: "0.9rem"
                    }}
                  >
                    <FontAwesomeIcon icon={faTimes} /> Cancel
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Categories List */}
          <div
            style={{
              background: "#fff",
              borderRadius: "18px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 4px 6px -1px rgba(0,0,0,0.03)",
              overflow: "hidden"
            }}
          >
            <div
              style={{
                padding: "18px 24px",
                borderBottom: "1px solid #f1f5f9",
                background: "#fafbff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontWeight: 800,
                  color: "#0f172a",
                  fontSize: "1.05rem"
                }}
              >
                All Available Categories
              </h3>
              <span
                style={{
                  background: "#dbeafe",
                  color: "#1d4ed8",
                  borderRadius: "20px",
                  padding: "4px 14px",
                  fontSize: "0.82rem",
                  fontWeight: 700
                }}
              >
                {categories.length} Categories
              </span>
            </div>

            <div style={{ padding: "20px 24px" }}>
              {loading ? (
                <div style={{ textAlign: "center", padding: "40px 0", color: "#64748b" }}>
                  <FontAwesomeIcon
                    icon={faSpinner}
                    spin
                    style={{ fontSize: "2rem", color: "#2563eb", marginBottom: "10px" }}
                  />
                  <p>Loading categories...</p>
                </div>
              ) : categories.length === 0 ? (
                <p style={{ color: "#94a3b8", textAlign: "center", margin: "20px 0" }}>
                  No categories found. Click "Add Category" above to create one.
                </p>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  {categories.map((cat, index) => (
                    <div
                      key={cat.id || index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "14px 20px",
                        background: "#f8fafc",
                        borderRadius: "12px",
                        border: "1px solid #e2e8f0",
                        flexWrap: "wrap",
                        gap: "12px"
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                        <span style={{
                          fontWeight: 700,
                          color: "#64748b",
                          fontSize: "0.85rem",
                          minWidth: "24px"
                        }}>
                          #{index + 1}
                        </span>
                        <div>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <h4 style={{ margin: 0, fontSize: "1rem", fontWeight: 700, color: "#0f172a" }}>
                              {cat.name}
                            </h4>
                            {(cat.is_trending === 1 || cat.is_trending === true) && (
                              <span
                                style={{
                                  background: "#ffedd5",
                                  color: "#ea580c",
                                  padding: "2px 8px",
                                  borderRadius: "6px",
                                  fontSize: "0.72rem",
                                  fontWeight: 800,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "4px"
                                }}
                              >
                                <FontAwesomeIcon icon={faFire} /> Trending
                              </span>
                            )}
                          </div>
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "5px",
                              marginTop: "4px",
                              background: cat.course_count > 0 ? "#e0f2fe" : "#f1f5f9",
                              color: cat.course_count > 0 ? "#0284c7" : "#64748b",
                              padding: "2px 8px",
                              borderRadius: "6px",
                              fontSize: "0.76rem",
                              fontWeight: 600
                            }}
                          >
                            <FontAwesomeIcon icon={faBookOpen} style={{ fontSize: "0.7rem" }} />
                            {cat.course_count || 0} {cat.course_count === 1 ? "Course" : "Courses"}
                          </span>
                        </div>
                      </div>

                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <button
                          onClick={() => toggleTrending(cat)}
                          style={{
                            backgroundColor: (cat.is_trending === 1 || cat.is_trending === true) ? "#fff7ed" : "#f8fafc",
                            color: (cat.is_trending === 1 || cat.is_trending === true) ? "#ea580c" : "#64748b",
                            border: (cat.is_trending === 1 || cat.is_trending === true) ? "1.5px solid #fdba74" : "1.5px solid #cbd5e1",
                            borderRadius: "8px",
                            padding: "8px 14px",
                            cursor: "pointer",
                            fontSize: "0.85rem",
                            fontWeight: 700,
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            transition: "all 0.2s ease"
                          }}
                          title="Toggle Trending status for this category"
                        >
                          <FontAwesomeIcon icon={faFire} />
                          {(cat.is_trending === 1 || cat.is_trending === true) ? "Trending ★" : "Make Trending"}
                        </button>
                        <button
                          onClick={() => handleEdit(cat)}
                          style={{
                            backgroundColor: "#e0e7ff",
                            color: "#4338ca",
                            border: "none",
                            borderRadius: "8px",
                            padding: "8px 14px",
                            cursor: "pointer",
                            fontSize: "0.85rem",
                            fontWeight: 700,
                            display: "flex",
                            alignItems: "center",
                            gap: "6px"
                          }}
                          title="Edit Category"
                        >
                          <FontAwesomeIcon icon={faEdit} /> Edit
                        </button>
                        <button
                          onClick={() => { setDeleteModal(true); setDeleteId(cat.id); }}
                          style={{
                            backgroundColor: "#fee2e2",
                            color: "#dc2626",
                            border: "none",
                            borderRadius: "8px",
                            padding: "8px 14px",
                            cursor: "pointer",
                            fontSize: "0.85rem",
                            fontWeight: 700,
                            display: "flex",
                            alignItems: "center",
                            gap: "6px"
                          }}
                          title="Delete Category"
                        >
                          <FontAwesomeIcon icon={faTrash} /> Delete
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </main>
      </section>

      {/* Delete Confirmation Modal */}
      <Modal
        title="Confirm Category Deletion"
        open={deleteModal}
        onOk={handleDelete}
        onCancel={() => { setDeleteModal(false); setDeleteId(null); }}
        okText="Yes, Delete"
        okButtonProps={{ danger: true }}
      >
        <p style={{ color: "#334155", fontSize: "0.95rem" }}>
          Are you sure you want to delete this category? Any courses assigned to this category will become uncategorized.
        </p>
      </Modal>
    </div>
  );
}

export default DCategories;
